/* eslint-disable react/prop-types */
// TODO: fazer a validação de proptypes
import React from 'react';
import styled from 'styled-components';

import { Draggable, Droppable } from 'react-beautiful-dnd';
import { FlexDiv } from '../../../../../base/Div';
import { OptionWrapper } from '../option-wrapper';
import { MobileScreen } from '../../../../../styles/ConstantMediaQuery';
import { DefaultScrollBar } from '../../../../../styles/ScrollBar';
import DragAndDropIndicator from '../../../../../icons/DragAndDropIndicator';

const defaultProps = {
    options: [],
};

const droppableProps = {
    droppableId: 'SELECTOR', type: 'SELECTOR',
};

const SubMenuWithDraggableOption = ({
    options, onClick,
}) => (
    <Wrapper>
        <Droppable {...droppableProps}>
            {provided => (
                <DraggableWrapper
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                >
                    {Object.values(options).map(option => (
                        <Draggable
                            draggableId={option.value}
                            index={option.index}
                            isDragDisabled={false}
                            key={option.value}
                        >
                            {draggableProvided => (
                                <div
                                    ref={draggableProvided.innerRef}
                                    {...draggableProvided.draggableProps}
                                    {...draggableProvided.dragHandleProps}
                                >
                                    <Option
                                        {...option}
                                        onClick={() => onClick(option)}
                                    >
                                        <StyledDragAndDropIcon className="dragAndDropIcon" />
                                    </Option>
                                </div>
                            )}
                        </Draggable>
                    ))}
                </DraggableWrapper>
            )}
        </Droppable>
    </Wrapper>
);


const Option = styled(OptionWrapper)`
    position: relative;
    padding-left: 28px;
    
    &:hover {
        .dragAndDropIcon {
            visibility: visible;
        }
    }
    
    .dragAndDropIcon {
        visibility: hidden;
    }
    
    @media ${MobileScreen}{
        .dragAndDropIcon {
           visibility: visible;
        }
    }
`;

const StyledDragAndDropIcon = styled(DragAndDropIndicator)`
    position: absolute;
    left: 2px;
`;

const DraggableWrapper = styled(FlexDiv)`
    flex-direction: column;
    max-height: 250px;
    overflow: auto;
    width: 100%;
    
    ${DefaultScrollBar}
`;

const Wrapper = styled(DraggableWrapper)`
    max-height: 250px;
    overflow: auto;
    margin: 16px 36px 0 28px;
    
    ${DefaultScrollBar}
`;


SubMenuWithDraggableOption.defaultProps = defaultProps;

export default SubMenuWithDraggableOption;
